import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/somewhat-satisfied.vue
var s = {
	name: "DtIconSomewhatSatisfied",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--somewhat-satisfied"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Somewhat Satisfied",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.899 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.399 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm3.5-1.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5ZM3.353 7.196a.5.5 0 0 1 .7-.093l.083.063-.303.397.303-.397c.284.217.63.334.987.334h1.508c.38 0 .747-.133 1.039-.376l.32.385-.32-.385.01-.008a.5.5 0 1 1 .64.768l-.01.01a2.625 2.625 0 0 1-1.68.606H5.124c-.576 0-1.136-.19-1.594-.54l-.083-.063a.5.5 0 0 1-.093-.7Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=somewhat-satisfied.js.map